import React from "react";
import { Box } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { makeStyles } from "tss-react/mui";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
const useClasses = makeStyles()((theme, { highlightCurrent }) => ({
  breadcrumb: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap"
  },
  breadcrumbLinkParent: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.h6.fontSize
  },
  breadcrumbLinkCurrent: {
    display: "block",
    maxWidth: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
    fontSize: highlightCurrent ? theme.typography.h5.fontSize : theme.typography.h6.fontSize,
    lineHeight: highlightCurrent ? theme.typography.h5.lineHeight : theme.typography.h6.lineHeight
  }
}));
const Breadcrumb = ({ onClick, breadcrumbs, highlightCurrent = true }) => {
  const { classes } = useClasses({ highlightCurrent });
  const pushToRoute = (routeIndex) => {
    if (!breadcrumbs[routeIndex].clickable) {
      return;
    }
    if (routeIndex !== 0 && breadcrumbs.length > 1 || breadcrumbs[routeIndex].clickable) {
      onClick(breadcrumbs[routeIndex]);
    }
  };
  const lastBreadcrumbIndex = breadcrumbs.length - 1;
  return breadcrumbs.length > 1 ? /* @__PURE__ */ React.createElement(Box, { className: classes.breadcrumb }, /* @__PURE__ */ React.createElement(Breadcrumbs, { "aria-label": "breadcrumb" }, breadcrumbs.slice(0, -1).map((breadcrumb, index) => /* @__PURE__ */ React.createElement(
    LinkText,
    {
      key: breadcrumb.url,
      title: breadcrumb.title,
      onClick: () => pushToRoute(index),
      underline: "none",
      className: classes.breadcrumbLinkParent
    }
  )), breadcrumbs[lastBreadcrumbIndex] ? /* @__PURE__ */ React.createElement(
    LinkText,
    {
      key: breadcrumbs[lastBreadcrumbIndex].url,
      title: breadcrumbs[lastBreadcrumbIndex].title,
      onClick: () => pushToRoute(lastBreadcrumbIndex),
      underline: "none",
      className: classes.breadcrumbLinkCurrent
    }
  ) : null)) : null;
};
export {
  Breadcrumb
};
//# sourceMappingURL=BreadCrumb.js.map
